import React from "react";

export const Banner = ({ href }) => {
  return (
    <div class="mx-1 md:mx-4">
      <div
        className="max-w-2xl mx-auto p-2 font-bold text-white rounded-lg antialiased leading-relaxed bg-blue-700"
        style={{
          background:
            "linear-gradient(45deg, rgb(240, 148, 51) 0px, rgb(230, 104, 60) 25%, rgb(220, 39, 67) 50%, rgb(204, 35, 102) 75%, rgb(188, 24, 136) 100%)"
        }}
      >
        Know what your friends think about you? -
        <a href={href} style={{ "text-decoration": "underline" }}>
          Click here
        </a>
      </div>
    </div>
  );
};
